import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import FindTheCorrectWord from './FindTheCorrectWord'


axios.defaults.withCredentials = true;

function FindTheCorrectWordAudio() {
    return (
        <FindTheCorrectWord
            audio={true}
            instructions={"Ascolta la parola e scegli quella scritta correttamente"}
            type={"alternative uditivo"}>
        </FindTheCorrectWord>
    );
}

export default FindTheCorrectWordAudio;

